"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModesComparison = exports.ModeRowSchema = void 0;
const z = require("zod");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const comparison_spec_1 = require("../comparison-spec");
exports.ModeRowSchema = z.object({
    id: z.string(),
    characteristic: z.string(),
    minVal: z.number().nullable(),
    nominalVal: z.number().nullable(),
    maxVal: z.number().nullable(),
    targetSignal: z.string(),
    relativeSignal: z.string(),
    referencedBy: z.string(),
});
const IDENTITY_COLUMNS = [
    'characteristic',
    'maxVal',
    'minVal',
    'nominalVal',
    'relativeSignal',
    'targetSignal',
];
class ModeContentIdentityAlignment extends comparison_spec_1.SetAlignment {
    identityOf(row, normalize) {
        return JSON.stringify(IDENTITY_COLUMNS.map((column) => [column, normalize(column, row[column], row)]));
    }
}
class ModesComparison extends comparison_spec_1.ComparisonSpec {
    constructor() {
        super(...arguments);
        this.alignment = new ModeContentIdentityAlignment();
    }
    toRows(data) {
        return data;
    }
    fromRows(rows) {
        return rows;
    }
    rowKeyOf(row) {
        return this.alignment.identityOf(row, (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if ((column === 'targetSignal' || column === 'relativeSignal') && typeof value === 'string') {
            return (0, signal_name_normalization_1.normalizeSignalNameForComparison)(value);
        }
        return super.normalize(column, value, row);
    }
}
exports.ModesComparison = ModesComparison;
//# sourceMappingURL=modes.comparison.js.map